import React from "react";

/**
 * Renderiza el icono utilizado para la opción **Asociar perfil**.
 *
 * El componente encapsula un icono SVG para mantener una apariencia
 * consistente y facilitar su reutilización dentro de los menús del
 * Header General.
 *
 * @returns {JSX.Element} IconAssociateProfile
 */
export const IconAssociateProfile = () => (
    <svg
        className="mr-3"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15 2.458C14.0291 2.1536 13.0175 1.99916 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22.0008 10.9825 21.8464 9.97088 21.542 9"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.5 19.5L6.06 18.52C6.4973 17.7544 7.12926 17.1181 7.8918 16.6756C8.65434 16.233 9.52034 15.9999 10.402 16H13.598C14.4795 16.0001 15.3453 16.2333 16.1076 16.6758C16.87 17.1184 17.5018 17.7546 17.939 18.52L18.499 19.5M15 10C15 10.7956 14.6839 11.5587 14.1213 12.1213C13.5587 12.6839 12.7956 13 12 13C11.2044 13 10.4413 12.6839 9.87868 12.1213C9.31607 11.5587 9 10.7956 9 10C9 9.20435 9.31607 8.44129 9.87868 7.87868C10.4413 7.31607 11.2044 7 12 7C12.7956 7 13.5587 7.31607 14.1213 7.87868C14.6839 8.44129 15 9.20435 15 10ZM18.974 2.021C18.98 1.993 19.02 1.993 19.026 2.021C19.1749 2.74834 19.5341 3.41595 20.0591 3.94092C20.5841 4.46589 21.2517 4.82512 21.979 4.974C22.007 4.98 22.007 5.02 21.979 5.026C21.2517 5.17488 20.5841 5.53411 20.0591 6.05908C19.5341 6.58405 19.1749 7.25166 19.026 7.979C19.02 8.007 18.98 8.007 18.974 7.979C18.8251 7.25166 18.4659 6.58405 17.9409 6.05908C17.4159 5.53411 16.7483 5.17488 16.021 5.026C15.993 5.02 15.993 4.98 16.021 4.974C16.7483 4.82512 17.4159 4.46589 17.9409 3.94092C18.4659 3.41595 18.8251 2.74834 18.974 2.021Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);